module.exports = __webpack_public_path__ + "img/a144a976cf6267414f0232cce60f277f.514b0a41.png";